module.exports = __webpack_public_path__ + "img/xrterra-blue-logo.c84cfc84.png";